import { render, staticRenderFns } from "./RelationDetails.vue?vue&type=template&id=0d3e595f&scoped=true"
import script from "./RelationDetails.vue?vue&type=script&lang=js"
export * from "./RelationDetails.vue?vue&type=script&lang=js"
import style0 from "./RelationDetails.vue?vue&type=style&index=0&id=0d3e595f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3e595f",
  null
  
)

export default component.exports